<template>
  <article>
    <Feature :title="$t('JOB_SCHEDULING')" :iconClass="'fa-user-circle-o'">
      <Table border :columns="schemaList" :data="jobs">
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" shape="circle" icon="ios-jet" @click="trigger(row)"></Button>
        </template>
        <template slot-scope="{ row }" slot="history">
          <Button type="primary" shape="circle" icon="ios-paper" @click="history(row)"></Button>
        </template>
      </Table>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="historyModel" :title="$t('ABNORMAL')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table
          :columns="historyColumnList"
          :data="historys"
          max-height="800"
        ></Table>
      </div>
    </Modal>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  name: "JobScheduling",
  data() {
    return {
      jobs: [],
      historyModel: false,
      historys: [],
      schemaList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('JOB_SCHEDULE_NAME')
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          align: 'center',
          key: "name",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LAST_EXECUTION_TIME')
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            let tempDate = new Date(params.row["previousFireTime"].substring(0, 19))
            return h("span", {}, tempDate.toString('YYYY-MM-dd')) 
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('NEXT_EXECUTION_TIME')
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            let tempDate = new Date(params.row["nextFireTime"].substring(0, 19))
            return h("span", {}, tempDate.toString('YYYY-MM-dd')) 
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCHEDULE_JOB_DESCRIPTION')
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          align: 'center',
          key: "description",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION')
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          slot: 'action',
          align: 'center',
          width: 120,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CHANGE_LOG')
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          slot: 'history',
          align: 'center',
          width: 120,
        },
      ],
      historyColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('LAST_EXECUTION_TIME')
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            let tempDate = new Date(params.row["fireTime"].substring(0, 19))
            return h("span", {}, tempDate.toString('YYYY-MM-dd')) 
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS')
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          align: 'center',
          key: "status",
        },
      ]
    }
  },
  created() {
    this.toggleLoading(true)
    this.$authHttp
      .get("/job/triggers/find-all",)
      .then((response) => {
        this.toggleLoading(false)
        response.data.forEach(element => {
          this.jobs.push(element)
        })
      })
      .catch(() => {})
  },
  methods: {
    ...mapGetters([
      "getModalSize"
    ]),
    ...mapActions([
      'toggleLoading'
    ]),
    trigger(row) {
      this.toggleLoading(true)
      this.$authHttp
      .put("job/trigger/"+ row.name)
      .then((response) => {
        this.toggleLoading(false)
        console.log(response)
      })
      .catch(() => {})
    },
    history(row) {
      this.toggleLoading(true)
      this.$authHttp
      .get("job/triggerHistorys/"+ row.jobName)
      .then((response) => {
        this.toggleLoading(false)
        console.log(response)
        this.historyModel = true
        this.historys = response.data.content
      })
      .catch(() => {})
    }  
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    }
  }
}
</script>

<style scoped>
</style>
